import { render, staticRenderFns } from "./payment-history-view.vue?vue&type=template&id=708da4a8&scoped=true"
import script from "./payment-history-view.vue?vue&type=script&lang=js"
export * from "./payment-history-view.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "708da4a8",
  null
  
)

export default component.exports